module.exports = __webpack_public_path__ + "static/media/doc09.062c10cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/doc09.png
// module id = 61
// module chunks = 0